import { render, staticRenderFns } from "./ProductListBatchPricePercentageManagementView.vue?vue&type=template&id=6bb04b2b&scoped=true&"
import script from "./ProductListBatchPricePercentageManagementView.vue?vue&type=script&lang=js&"
export * from "./ProductListBatchPricePercentageManagementView.vue?vue&type=script&lang=js&"
import style0 from "./ProductListBatchPricePercentageManagementView.vue?vue&type=style&index=0&id=6bb04b2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb04b2b",
  null
  
)

export default component.exports